import logo from './logo.svg';
import './App.css';
import AppRoutes from './routes/AppRoutes';

import 'bootstrap/dist/css/bootstrap.min.css';

//переиспользованные стили
import "./styles/reuse/text.css";

import "./styles/reuse/buttons.css";

import "./styles/reuse/blocks.css";
import "./styles/reuse/navbar.css";

//персональные стили
import "./styles/personal/AuthPage/AuthPage.css";
import "./styles/personal/ArchivePage/ArchivePage.css";
import "./styles/personal/PlaningAuditPage/PlaningAuditPage.css";
import "./styles/personal/AdminPage/AdminPage.css";
import "./styles/personal/AdminPage/AdminLogsPage.css";
import "./styles/personal/AuditResultPage/AuditResultPage.css";
import "./styles/personal/AuditTestPage/AuditTestPage.css"

function App() {
  return (
    <>
    <AppRoutes/>
    </>
  );
}

export default App;
